import { render, staticRenderFns } from "./EditProgram.vue?vue&type=template&id=f4beb402&"
import script from "./EditProgram.vue?vue&type=script&lang=js&"
export * from "./EditProgram.vue?vue&type=script&lang=js&"
import style0 from "./EditProgram.vue?vue&type=style&index=0&id=f4beb402&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports